import cn from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useDeviceType } from '@cian/ui-kit';

import * as styles from './DailyrentReviewsListContainer.css';
import { DailyrentReviewContainer } from '../DailyrentReviewContainer';
import { getReviewIds } from '../../selectors/reviews';
import { EmptyListContainer } from '../EmptyListContainer';
import { closeAllAnswersAction, openAllAnswersAction } from '../../actions/reviews';

interface IDailyrentReviewsListContainerProps {
  className?: string;
}

export const DailyrentReviewsListContainer = ({ className }: IDailyrentReviewsListContainerProps) => {
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const isDesktop = deviceType === 'desktop';

  const ids = useSelector(getReviewIds);

  useEffect(() => {
    if (isDesktop) {
      dispatch(openAllAnswersAction());
    } else {
      dispatch(closeAllAnswersAction());
    }
  }, [isDesktop]);

  if (ids.length === 0) {
    return <EmptyListContainer showExtra={false} />;
  }

  return (
    <section className={cn(styles['root'], className)}>
      {ids.map(reviewId => (
        <DailyrentReviewContainer key={reviewId} reviewId={reviewId} />
      ))}
    </section>
  );
};
